module.exports = __webpack_public_path__ + "media/images/icons/twotone/dislike-e8b7d6ce4136f8a461edb214cf336576.svg";